import { render } from "./EmployeeTableRowMenu.vue?vue&type=template&id=4650c059"
import script from "./EmployeeTableRowMenu.vue?vue&type=script&lang=ts"
export * from "./EmployeeTableRowMenu.vue?vue&type=script&lang=ts"
script.render = render

export default script